<script>
import { mapActions } from 'vuex'
import { useAlert } from 'dashboard/composables'

export default {
  name: 'NewQuestionModal',
  props: {
    selectedInbox: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      question: '',
      loading: false
    }
  },
  methods: {
    ...mapActions('whitelist', ['addWhitelistQuestion']),

    close() {
      this.$emit('close')
      this.question = ''
    },

    async submit() {
      const trimmedQuestion = this.question.trim()
      if (!trimmedQuestion) return

      if (!this.selectedInbox?.id) {
        useAlert('Please select an inbox first')
        return
      }

      this.loading = true
      try {
        await this.addWhitelistQuestion({
          accountId: this.$route.params.accountId,
          inboxId: this.selectedInbox.id,
          question: trimmedQuestion,
        })
        useAlert('Question added successfully!')
        this.$emit('refresh')
        this.close() 
      } catch (e) {
        console.log(e)
        useAlert('Failed to add question') 
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-slate-800/50 z-50"
  >
    <div class="bg-white dark:bg-slate-800 rounded-lg shadow-lg w-full max-w-md p-6">
      <h2 class="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
        Add New Question
      </h2>

      <label class="block text-slate-700 dark:text-slate-200 mb-2">
        Question:
      </label>
      <input
        v-model="question"
        type="text"
        placeholder="Enter question"
        class="w-full border rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-woot-500"
        :disabled="loading"
      />

      <div class="flex justify-end gap-2">
        <woot-button color-scheme="secondary" @click="close" :disabled="loading">
          Cancel
        </woot-button>
        <woot-button color-scheme="primary" @click="submit" :disabled="loading">
          <span v-if="loading">Adding...</span>
          <span v-else>Add</span>
        </woot-button>
      </div>
    </div>
  </div>
</template>
